import { commentsData } from '@/mocks/home';

export default function SectionComments() {
  return (
    <section
      id="comments"
      className="py-16 md:py-20 bg-background-100"
    >
      <div className="max-w-[1920px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-block text-xs font-medium text-primary-500 bg-primary-500/10 px-3 py-1 rounded-full mb-3">
            真实反馈
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            用户评价
          </h2>
          <p className="text-sm text-foreground-400 mt-2">来自追剧达人们的真实声音</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 max-w-6xl mx-auto">
          {commentsData.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-200/70 rounded-xl border border-background-300/40 p-5 md:p-6 flex flex-col"
            >
              {/* Stars */}
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-xs ${i < comment.rating ? 'ri-star-fill text-primary-500' : 'ri-star-fill text-foreground-700'}`}
                  ></i>
                ))}
              </div>

              <p className="text-sm text-foreground-300 leading-relaxed flex-1 mb-4 line-clamp-5">
                &ldquo;{comment.content}&rdquo;
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-background-300/40">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-9 h-9 rounded-full object-cover shrink-0"
                />
                <div>
                  <div className="text-sm font-semibold text-foreground-100">{comment.name}</div>
                  <div className="text-[11px] text-foreground-500">{comment.date}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}